import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API from "../Components/Authentification/api"

// Thunk pour charger les stats clients
export const fetchClientsStats = createAsyncThunk(
    "clients/fetchClientsStats",
    async (token, { rejectWithValue }) => {
        try {
            const res = await API.get("/admin/clients-stats", {
                headers: {
                    Accept: "application/json",
                },
            });

            return res.data;
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || err.message);
        }
    }
);

const clientsSlice = createSlice({
    name: "clients",
    initialState: {
        stats: null,
        loading: false,
        error: null,
        lastFetched: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchClientsStats.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchClientsStats.fulfilled, (state, action) => {
                state.stats = action.payload;
                state.loading = false;
                state.lastFetched = Date.now();
            })
            .addCase(fetchClientsStats.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default clientsSlice.reducer;
